"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Component = void 0;
var _react = _interopRequireDefault(require("react"));
var _Page = require("../Page");
const _excluded = ["data"];
/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
const ComponentNotFound = ({
  typeId
}) => /*#__PURE__*/_react.default.createElement("div", null, `Component type '${typeId}' not found!`);
/**
 * This component will render a page designer page given its serialized data object.
 *
 * @param {PageProps} props
 * @param {Component} props.component - The page designer component data representation.
 * @returns {React.ReactElement} - Experience component.
 */
const Component = ({
  component
}) => {
  const pageContext = (0, _Page.usePageContext)();
  const ComponentClass = (pageContext === null || pageContext === void 0 ? void 0 : pageContext.components[component.typeId]) || ComponentNotFound;
  const {
      data
    } = component,
    rest = _objectWithoutProperties(component, _excluded);
  return /*#__PURE__*/_react.default.createElement("div", {
    id: component.id,
    className: "component"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement(ComponentClass, _extends({}, rest, data))));
};
exports.Component = Component;
Component.displayName = 'Component';
var _default = exports.default = Component;